const InfoBar = ({ children }) => {
  return (
    <div className="gap-2 rounded flex flex-row justify-start items-end">
      {children}
    </div>
  );
};

export default InfoBar;
